import {  QUERY_POST_SET_WORKSHOP_APPOINTMENT, QUERY_POST_SET_DOCUMENTATION,
  QUERY_POST_SET_CLAIMS, QUERY_POST_FACTORY_COMMENT, QUERY_POST_ADVANCE_FACTORY_CASE,
   QUERY_POST_SET_TERMINATIONS, QUERY_POST_SET_SUBSTITUTION, QUERY_POST_SET_DELIVERY, QUERY_POST_REGRESS_FACTORY_CASE} from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk'


  export const setWorkshopAppointment = baseThunk("cases/setWorkshopAppointment", QUERY_POST_SET_WORKSHOP_APPOINTMENT, "POST")

  export const setDocumentation = baseThunk("cases/setDocumentation", QUERY_POST_SET_DOCUMENTATION, "POST")

  export const setClaims = baseThunk("cases/setClaims", QUERY_POST_SET_CLAIMS, "POST")

  export const sendFactoryComment = baseThunk('currentCase/sendFactoryComment', QUERY_POST_FACTORY_COMMENT, "POST")

  export const advanceFactoryCase = baseThunk("currentCase/advanceFactoryCase", QUERY_POST_ADVANCE_FACTORY_CASE, "POST")

  export const setTerminations = baseThunk("cases/setTerminations", QUERY_POST_SET_TERMINATIONS, "POST")

  export const setSubstitutionVehicle = baseThunk("cases/setSubstitution", QUERY_POST_SET_SUBSTITUTION, "POST")

  export const setDelivery = baseThunk("cases/setDelivery", QUERY_POST_SET_DELIVERY, "POST")

  export const regressFactoryCase = baseThunk("currentCase/regressCase", QUERY_POST_REGRESS_FACTORY_CASE, "POST")



